import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { getAdminFeedback } from '@/api/adminService'

export function useAdminFeedback(
  page: number,
  pageSize: number,
  feedbackType?: string,
  sortOrder?: string,
) {
  return useQuery({
    queryKey: ['admin', 'feedback', page, pageSize, feedbackType, sortOrder],
    queryFn: () =>
      getAdminFeedback({
        page,
        page_size: pageSize,
        feedback_type: feedbackType,
        sort_order: sortOrder,
      }),
    placeholderData: keepPreviousData,
  })
}
